import React from "react";
import { Box, Grid, Typography, makeStyles, Paper } from "@material-ui/core";
import { School, Group, TrendingUp } from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f9fafb",
    padding: theme.spacing(8, 2),
    textAlign: "center",
  },
  sectionTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    color: "#6b7280",
    marginBottom: theme.spacing(5),
  },
  card: {
    padding: theme.spacing(4),
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    backgroundColor: "#fff",
    minHeight: 300,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  stepCircle: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 16px",
    fontWeight: 600,
  },
  icon: {
    fontSize: 40,
    marginBottom: theme.spacing(2),
  },
  greenText: {
    color: "#10b981", // Tailwind green-500
    fontSize: "0.85rem",
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  footerNote: {
    marginTop: theme.spacing(4),
    fontSize: "0.9rem",
    color: "#6b7280",
  },
}));

const steps = [
  {
    number: 1,
    color: "#2563eb", // blue
    cardBg: "rgb(213 229 249)",
    cardBorder: "rgb(132 177 234)",
    icon: <School style={{ fontSize: 40, color: "#2563eb" }} />,
    title: "Register Your School",
    description:
      "Create an account and set up your school profile with ease. Our onboarding process is designed to get you started quickly.",
  },
  {
    number: 2,
    color: "#10b981", // green
    cardBg: "rgb(206 242 226)",
    cardBorder: "rgb(29 221 132)",
    icon: <Group style={{ fontSize: 40, color: "#10b981" }} />,
    title: "Add Teachers & Students",
    description:
      "Manage classroom details and student information efficiently. Our intuitive interface makes data management simple.",
  },
  {
    number: 3,
    color: "#f97316", // orange
    cardBg: "#fff7ed",
    cardBorder: "#fdba74",
    icon: <TrendingUp style={{ fontSize: 40, color: "#f97316" }} />,
    title: "Track Progress",
    description:
      "Monitor activities and communicate with parents effectively. Real-time insights help improve learning outcomes.",
  },
];

const HowItWorks = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="h5" className={classes.sectionTitle}>
        How It Works
      </Typography>
      <Typography variant="subtitle1" className={classes.subtitle}>
        Get started with MonteStory in three simple steps and transform your school management experience today.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {steps.map((step) => (
          <Grid item xs={12} sm={6} md={4} key={step.number}>
            <Paper
              className={classes.card}
              elevation={0}
              style={{ backgroundColor: step.cardBg, borderColor: step.cardBorder }}
            >
              <div>
                <div
                  className={classes.stepCircle}
                  style={{ backgroundColor: step.color }}
                >
                  {step.number}
                </div>
                <div>{step.icon}</div>
                <Typography variant="h6" gutterBottom>
                  {step.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {step.description}
                </Typography>
              </div>
              
            </Paper>
          </Grid>
        ))}
      </Grid>

     
    </Box>
  );
};

export default HowItWorks;
